module.exports = __webpack_public_path__ + "img/TRT_logo_mobile.f506657f.png";